export function turboFrame (name, src, attributes = {}) {
  const frame = document.createElement('turbo-frame')

  frame.setAttribute('id', name)
  frame.setAttribute('src', src)
  if (Object.keys(attributes).length !== 0) {
    Object.keys(attributes).forEach((attr) => {
      frame.setAttribute(attr, attributes[attr])
    })
  }

  return frame
}
